export function fetch(id) { return { type: 'STAFFS/FETCH', id } }
export function fetch_one(id) { return { type: 'STAFF/FETCH', id } }
export function archive(id, IdProperty) { return { type: 'STAFF/ARCHIVE', id, IdProperty } }
export function toggle(id, IsActive) { return { type: 'STAFF/TOGGLE', id, IsActive } }
export function clean() { return { type: 'STAFF/CLEAR' } }